<div class="xma-modal">
  <header class="xma-modal__header">
    <h2 class="xma-modal__title smsir-h5-lg tw-text-[rgb(var(--text-primary))]">
      دستیار هوشمند ایکسما
    </h2>
  </header>

  <div class="xma-modal__filters">
    <div class="xma-modal__filter">
      <smsir-dropdown
        [(ngModel)]="selectedStyle"
        [ngModelOptions]="{standalone: true}"
        placeholder="انتخاب سبک"
      >
        <smsir-dropdown-trigger [chevron]="true"></smsir-dropdown-trigger>
        <smsir-dropdown-menu>
          <smsir-dropdown-item
            *ngFor="let o of styleOptions"
            [value]="o.value"
            [title]="o.name"
            [prefix]="false"
            [suffix]="false"
          ></smsir-dropdown-item>
        </smsir-dropdown-menu>
      </smsir-dropdown>
    </div>

    <div class="xma-modal__filter">
      <smsir-dropdown
        [(ngModel)]="selectedGoal"
        [ngModelOptions]="{standalone: true}"
        placeholder="انتخاب هدف"
      >
        <smsir-dropdown-trigger [chevron]="true"></smsir-dropdown-trigger>
        <smsir-dropdown-menu>
          <smsir-dropdown-item
            *ngFor="let o of goalOptions"
            [value]="o.value"
            [title]="o.name"
            [prefix]="false"
            [suffix]="false"
          ></smsir-dropdown-item>
        </smsir-dropdown-menu>
      </smsir-dropdown>
    </div>

    <div class="xma-modal__filter">
      <smsir-dropdown
        [(ngModel)]="selectedLength"
        [ngModelOptions]="{standalone: true}"
        placeholder="انتخاب طول"
      >
        <smsir-dropdown-trigger [chevron]="true"></smsir-dropdown-trigger>
        <smsir-dropdown-menu>
          <smsir-dropdown-item
            *ngFor="let o of lengthOptions"
            [value]="o.value"
            [title]="o.name"
            [prefix]="false"
            [suffix]="false"
          ></smsir-dropdown-item>
        </smsir-dropdown-menu>
      </smsir-dropdown>
    </div>
  </div>

  <div class="xma-modal__columns">
    <section class="xma-modal__column">
      <h3 class="xma-modal__section-title smsir-label-sm tw-text-[rgb(var(--text-section-label))]">
        توضیح درخواست یا متن پیامک
      </h3>

      <textarea
        rows="7"
        smsirTextarea
        [(ngModel)]="previewText"
        placeholder="در صورت نداشتن متن پیامک، ایده خود را توضیح دهید."
        [dir]="previewText ? 'auto' : 'rtl'"
        class="xma-modal__textarea"
      ></textarea>
    </section>

    <section
      class="xma-modal__column xma-modal__column--generated"
      [class.xma-modal__column--hidden-mobile]="!isLoading && !isGenerated"
    >
      <h3 class="xma-modal__section-title smsir-label-sm tw-text-[rgb(var(--text-section-label))]">
        متن تولید شده
      </h3>

      <div
        class="xma-generated-box"
        [class.xma-generated-box--loading]="isLoading"
      >
        <ng-container *ngIf="isLoading; else generatedContent">
          <div
            class="xma-generated-box__skeleton"
            dir="rtl"
            role="status"
            aria-busy="true"
            aria-label="در حال تولید متن"
          >
            <span class="xma-skeleton-line xma-skeleton-line--generation tw-w-11/12"></span>
            <span class="xma-skeleton-line xma-skeleton-line--generation tw-w-full"></span>
            <span class="xma-skeleton-line xma-skeleton-line--generation tw-w-4/5"></span>
            <span class="xma-skeleton-line xma-skeleton-line--generation tw-w-2/3"></span>
          </div>
        </ng-container>

        <ng-template #generatedContent>
          <ng-container *ngIf="isGenerated; else generatedPlaceholder">
            <p class="xma-generated-box__text smsir-input-lg" dir="auto">{{ generatedText }}</p>

            <div *ngIf="!isTyping" class="xma-generated-box__actions">
              <button
                type="button"
                smsir-button
                variant="text"
                size="sm"
                iconOnly
                aria-label="کپی متن"
                (click)="onCopy(generatedText)"
              >
                <i class="ic-duotone ic-ui-essentional-copy" aria-hidden="true"></i>
              </button>

              <button
                type="button"
                smsir-button
                variant="ghost"
                size="sm"
                (click)="onReplace()"
              >
                جایگذاری
              </button>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #generatedPlaceholder>
          <p class="xma-generated-box__placeholder smsir-helper-md">
            متن تولید شده اینجا نمایش داده می‌شود
          </p>
        </ng-template>
      </div>

      <div class="xma-modal__sms-stats smsir-caption-lg tw-text-[rgb(var(--text-secondary))]">
        <span>{{ formatCount(generatedLocalSmsLen) }} / {{ formatCount(generatedContainer) }}</span>
        <span>|</span>
        <span>{{ formatCount(generatedSmsCount) }} پیامک</span>
      </div>
    </section>
  </div>

  <section #personalizationContainer class="xma-modal__personalization">
    <ng-container *ngIf="!isProfileLoading">
      <button
        *ngIf="!hasActivePersonalization"
        type="button"
        smsir-button
        variant="tertiary-colored"
        size="sm"
        class="xma-modal__personalization-trigger"
        (click)="togglePersonalizationPanel()"
      >
        <i class="ic-linear ic-ui-essentional-add-circle" aria-hidden="true"></i>
        افزودن اطلاعات کسب‌وکار
      </button>

      <div *ngIf="hasActivePersonalization" class="xma-modal__personalization-summary">
        <div class="xma-modal__personalization-summary-header">
          <span class="smsir-helper-md tw-text-[rgb(var(--text-secondary))]">
            شخصی‌سازی شده براساس:
          </span>

          <button
            type="button"
            smsir-button
            variant="text-colored"
            size="xs"
            class="xma-modal__edit-btn"
            (click)="togglePersonalizationPanel()"
          >
            ویرایش
            <i class="ic-linear ic-messages-pen-new-square" aria-hidden="true"></i>
          </button>
        </div>

        <div class="xma-modal__chips">
          <span
            *ngFor="let opt of activePersonalizationOptions"
            class="xma-personalization-chip"
          >
            <span>{{ opt.chipLabel }}</span>
            <button
              type="button"
              class="xma-personalization-chip__remove"
              [attr.aria-label]="'حذف ' + opt.chipLabel"
              (click)="onRemovePersonalizationChip(opt)"
            >
              ×
            </button>
          </span>
        </div>
      </div>
    </ng-container>

    <div *ngIf="isPersonalizationPanelOpen" class="xma-personalization-panel">
      <ng-container *ngIf="isProfileLoading; else profileContent">
        <p class="xma-personalization-panel__loading smsir-helper-md">در حال دریافت اطلاعات...</p>
      </ng-container>

      <ng-template #profileContent>
        <ng-container *ngIf="hasBusinessProfileData; else emptyState">
          <p class="xma-personalization-panel__eyebrow smsir-caption-lg">شخصی‌سازی پیام</p>

          <div class="xma-personalization-panel__header">
            <p class="smsir-input-lg tw-text-[rgb(var(--text-primary))]">استفاده از اطلاعات کسب‌وکار</p>

            <button
              *ngIf="!isProfileFullyCompleted"
              type="button"
              smsir-button
              variant="text-colored"
              size="sm"
              (click)="navigateToBusinessInfo()"
            >
              تکمیل مشخصات
            </button>
          </div>

          <ul class="xma-personalization-panel__list" role="list">
            <li *ngFor="let opt of personalizationOptions" class="xma-personalization-panel__item">
              <span
                class="smsir-helper-lg tw-text-[rgb(var(--text-primary))]"
                [class.tw-opacity-40]="!opt.value"
              >
                {{ opt.label }}
              </span>

              <label
                smsir-toggle
                [checked]="opt.isActive"
                [disabled]="!opt.value"
                (checkedChange)="onPersonalizationToggleChange(opt, $event)"
              ></label>
            </li>
          </ul>

          <p
            *ngIf="isProfileFullyCompleted"
            class="xma-personalization-panel__hint smsir-caption-lg"
          >
            این اطلاعات برای هدفمندتر نوشتن پیام به‌کار می‌روند.
          </p>

          <p
            *ngIf="!isProfileFullyCompleted"
            class="xma-personalization-panel__hint smsir-caption-lg"
          >
            * برای تولید متن‌های شخصی‌سازی شده، اطلاعات کسب‌وکارتان را تکمیل کنید.
          </p>
        </ng-container>

        <ng-template #emptyState>
          <div class="xma-personalization-panel__empty">
            <p class="smsir-input-lg tw-text-[rgb(var(--text-primary))]">
              اطلاعات کسب‌وکارتان را ثبت نکردید!
            </p>
            <p class="smsir-helper-md tw-text-[rgb(var(--text-secondary))]">
              برای تولید متن‌های شخصی‌سازی شده، ابتدا اطلاعات کسب‌وکارتان را تکمیل کنید.
            </p>
            <button
              type="button"
              smsir-button
              variant="secondary"
              size="sm"
              (click)="navigateToBusinessInfo()"
            >
              تکمیل مشخصات کسب‌وکار
            </button>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </section>

  <footer class="xma-modal__footer">
    <button
      type="button"
      smsir-button
      variant="text"
      size="sm"
      class="xma-modal__footer-cancel"
      (click)="onClose()"
    >
      انصراف
    </button>

    <button
      type="button"
      smsir-button
      variant="secondary"
      size="sm"
      class="xma-modal__footer-generate"
      [disabled]="isGenerateDisabled()"
      (click)="onGenerate()"
    >
      تولید متن
      <i class="ic-duotone ic-weather-stars-2" aria-hidden="true"></i>
    </button>
  </footer>
</div>
